import Person from "@/models/api/person/Person";
import axios, { AxiosResponse } from "axios";

class Service {
    public async searchParticipants(search: string): Promise<AxiosResponse<Person[]>> {
        return axios.get(`api/group/SearchParticipant?search=${search}`);
    }
}

export const ParticipantService: Service = new Service();